import { render, staticRenderFns } from "./HelpTabItem.vue?vue&type=template&id=87a13554&scoped=true"
import script from "./HelpTabItem.vue?vue&type=script&lang=ts"
export * from "./HelpTabItem.vue?vue&type=script&lang=ts"
import style0 from "./HelpTabItem.vue?vue&type=style&index=0&id=87a13554&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a13554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87a13554')) {
      api.createRecord('87a13554', component.options)
    } else {
      api.reload('87a13554', component.options)
    }
    module.hot.accept("./HelpTabItem.vue?vue&type=template&id=87a13554&scoped=true", function () {
      api.rerender('87a13554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Help/HelpTabItem.vue"
export default component.exports